import { createReducer, PayloadAction } from '@reduxjs/toolkit';
import * as ActionTypes from '../actions/types';
import { fetchSurveyTypeSuccessAction } from '../actions/survey';

type State = {
    surveyType: any;
    loading: boolean;
    posting: boolean;
    postingSuccessBody: {
        title: string;
        SurveyTypeId: string;
    } | null;
    errorMessage: any;
};
const INITIAL_STATE: State = {
    surveyType: [],
    loading: false,
    posting: false,
    postingSuccessBody: null,
    errorMessage: null,
};

const fetchSurveyType = (state: State): State => {
    return {
        ...state,
        loading: true,
        errorMessage: null,
        surveyType: [],
    };
};

const fetchSurveyTypeSuccess = (
    state: State,
    action: PayloadAction<fetchSurveyTypeSuccessAction>,
): State => {
    return {
        ...state,
        loading: false,
        surveyType:
            action.payload.body.data && action.payload.body?.data?.length >= 2
                ? action.payload.body.data.map((survey: any) => {
                      return { ...survey, completed: false };
                  })
                : action.payload.body.data.map((survey: any) => {
                      return { ...survey, completed: false };
                  }),
        errorMessage: null,
    };
};

const fetchSurveyTypeFailed = (state: State): State => {
    const mockErrorObject = {
        content: 'There are no surveys available for this Claim application.',
        link: null,
        surveyTypeId: null,
        title: ' ',
        error: true,
    } as any;
    return {
        ...state,
        loading: false,
        errorMessage: {
            ...mockErrorObject,
        },
    };
};

const postSurveyAnswers = (state: State): State => {
    return {
        ...state,
        posting: true,
        errorMessage: null,
    };
};

const postSurveyAnswersSuccess = (state: State, action: any): State => {
    const surveyTypeId = action.payload.body.data.surveyTypeId;
    return {
        ...state,
        posting: false,
        postingSuccessBody: action.payload.body.data,
        surveyType: state.surveyType.map((survey: any) => {
            if (survey.surveyTypeId === surveyTypeId) {
                return { ...survey, completed: true };
            } else {
                return { ...survey };
            }
        }),
        errorMessage: null,
    };
};

const postSurveyAnswersFailed = (state: State): State => {
    return {
        ...state,
        posting: false,
    };
};

const survey = createReducer(INITIAL_STATE, {
    [ActionTypes.FETCH_SURVEY_TYPE]: fetchSurveyType,
    [ActionTypes.FETCH_SURVEY_TYPE_SUCCESS]: fetchSurveyTypeSuccess,
    [ActionTypes.FETCH_SURVEY_TYPE_FAILED]: fetchSurveyTypeFailed,
    [ActionTypes.POST_SURVEY_ANSWERS]: postSurveyAnswers,
    [ActionTypes.POST_SURVEY_ANSWERS_SUCCESS]: postSurveyAnswersSuccess,
    [ActionTypes.POST_SURVEY_ANSWERS_FAILED]: postSurveyAnswersFailed,
});

export default survey;
